import monitorCallCenterHttpService from '../_services/monitorCallCenterHttpService'

export const monitorRamaisCallCenterMethods = {
  prioridadeFila(ramal) {
    let prioridade = ''
    const indexOperador = this.operadoresFila.findIndex(operador => operador.deviceId === ramal)

    if (indexOperador !== -1) {
      const indexQueue = this.operadoresFila[indexOperador].arrayQueues.findIndex(queue => queue.queue === this.idFila)

      if (indexQueue !== -1) {
        prioridade = this.operadoresFila[indexOperador].arrayQueues[indexQueue].penalty
      }
    }
    return prioridade
  },

  mostraLigacoesOperador(call) {
    return call.time
  },

  mostraFila(arrayChannels, key, queueEnters) {
    if (typeof arrayChannels[key] !== 'undefined' && arrayChannels[key].io === 'incoming') {
      let queueByCall = ''
      const indexQueue = this.getFilas.findIndex(queue => queue._id === queueEnters[key].queue)

      if (indexQueue !== -1) {
        queueByCall = this.getFilas[indexQueue].description

        if (queueByCall.length > 10) {
          return this.limitaNumeroDeCaracteresQueue(queueByCall)
        }

        return queueByCall
      }
      return 'D'
    }
    return ''
  },

  filaCompleta(arrayChannels, key) {
    let queueByCall = ''
    if (
      arrayChannels.length > 0 &&
      arrayChannels[key].io === 'incoming' &&
      typeof arrayChannels[key].queue !== 'undefined'
    ) {
      const indexQueue = this.filas.findIndex(queue => queue._id === arrayChannels[key].queue)
      if (indexQueue !== -1) {
        queueByCall = this.filas[indexQueue].description
      }
    }
    return queueByCall
  },

  mostraTempo(arrayChannels, key) {
    if (arrayChannels.length > 0) {
      return arrayChannels[key].time
    }

    return
  },

  selectItem(arrayChannels, indexChannel) {
    let iconCall = ''
    if (typeof arrayChannels !== 'undefined' && arrayChannels[indexChannel].io === 'incoming') {
      iconCall = 'call_received'
    } else {
      iconCall = 'call_made'
    }

    return iconCall
  },

  selectColor(ramal) {
    if (ramal.isNotRegistered) {
      return 'app-bar-card-monitor-background-color-grey'
    }
    if (typeof ramal.channels !== 'undefined' && ramal.channels.length > 0 && ramal.channels[ramal.callIndex].state) {
      if (ramal.channels[ramal.callIndex].state === 'RING' || ramal.channels[ramal.callIndex].state === 'RINGING') {
        return 'app-bar-card-monitor-background-color-orange'
      } else if (ramal.channels[ramal.callIndex].state === 'UP') {
        return 'app-bar-card-monitor-background-color-red'
      }
    }

    if (ramal.paused === '1') {
      return 'app-bar-card-monitor-background-color-yellow'
    }

    return 'app-bar-card-monitor-background-color-green'
  },

  verificaLigacoes(arrayChannels) {
    return arrayChannels.filter(channel => typeof channel.phoneNumber !== 'undefined').length
  },

  limitaNumeroDeCaracteres(ramal) {
    let tituloCard = ''

    const indexUser = this.user.findIndex(user => user.peer === ramal)

    if (indexUser !== -1) {
      tituloCard = `${ramal} - ${this.user[indexUser].user}`

      if (tituloCard.length > 30) {
        let arrayTituloCard = tituloCard.split('')
        arrayTituloCard.splice(27)
        tituloCard = `${arrayTituloCard.join('')}...`
      }
    }
    return tituloCard
  },

  limitaNumeroDeCaracteresQueue(queue) {
    if (queue.length > 10) {
      let arrayQueue = queue.split('')
      arrayQueue.splice(7)
      arrayQueue.push('...')
      let nomeQueueAlterado = arrayQueue.join('')
      return nomeQueueAlterado
    }

    return queue
  },

  showPausa(idPausa) {
    return this.pausasDialog.find(pausa => pausa.value === idPausa)
      ? this.pausasDialog.find(pausa => pausa.value === idPausa).text
      : ''
  },

  limitaNumeroDeCaracteresPausa(idPausa) {
    let textPausa = ''

    const indexPausa = this.pausasDialog.findIndex(pausa => pausa.value === idPausa)

    if (indexPausa !== -1) {
      textPausa = this.pausasDialog[indexPausa].text

      if (textPausa.length > 10) {
        let arrayTextPausa = textPausa.split('')
        arrayTextPausa.splice(7)
        arrayTextPausa.push('...')
        let nomePausaAlterado = arrayTextPausa.join('')
        return nomePausaAlterado
      }
    }

    return textPausa
  },

  abreDialogPausa(operador) {
    this.agentSelected = operador
    this.dialogPausas = true
  },

  async pauseUnpauseOperator(operador = null) {
    if (!operador) {
      let agente = this.agentSelected.agent.split('-')[1]
      this.dialogPausas = false

      const data = { agente, action: 'pause', pause_id: this.pausaDialog, realizouEvento: 'Monitor' }
      await monitorCallCenterHttpService.acoesOperador(data)
      this.pausaDialog = ''
    } else {
      let agente = operador.agent.split('-')[1]
      this.dialogPausas = false

      const data = { agente, action: 'unpause', realizouEvento: 'Monitor' }
      await monitorCallCenterHttpService.acoesOperador(data)
    }
  },

  async removeOperadorFromQueue(operador) {
    let resultado = window.confirm(`Deseja remover o operador "${operador.agent}" desta fila?`)

    if (resultado) {
      let agente = operador.agent.split('-')[1]
      const data = { agente, action: 'removerAgenteEmFila', queue_id: this.idFila, realizouEvento: 'Monitor' }
      await monitorCallCenterHttpService.acoesOperador(data)
    }
  },

  async logoutOperador(operador) {
    let resultado = window.confirm(`Deseja deslogar o operador "${operador.agent}"?`)

    if (resultado) {
      let agente = operador.agent.split('-')[1]
      const data = { agente, action: 'logout', realizouEvento: 'Monitor' }
      await monitorCallCenterHttpService.acoesOperador(data)
    }
  },

  async addAgenteOnQueue() {
    const findOperadorSocket = this.getRamais.find(
      ramal => ramal.agent && ramal.agent.split('-')[1] === this.operadorDialog
    )
    if (!findOperadorSocket) {
      const userNotFound = window.confirm(
        'Não foi possível concluir a solicitação devido ao operador selecionado ter se deslogado do sistema.'
      )
      if (userNotFound || !userNotFound) {
        this.dialogOperadores = false
        return
      }
    }
    const data = {
      agente: this.operadorDialog,
      action: 'addAgenteEmFila',
      queue_id: this.idFila,
      penalty: this.priorityDialog,
      realizouEvento: 'Monitor',
    }
    await monitorCallCenterHttpService.acoesOperador(data)
    this.priorityDialog = '1'
    this.dialogOperadores = false
  },

  ouvirLigacao(arrayChamadas, index) {
    this.channelOuvido = arrayChamadas[index].channel
    this.dialogSpy = true
  },

  async emitSpyEvent() {
    this.dialogSpy = false

    const data = { endpoint: this.ramalDialog, channelSpy: this.channelOuvido }
    await monitorCallCenterHttpService.spyChannel(data)
  },
}
